import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Uebax · Business Solutions Redefined</p>
        <h1>Transform Your Business with Intelligent Solutions</h1>
        <p className="lede">
          At Uebax, we empower businesses with cutting-edge automation, AI, and data analytics solutions. 
          Discover how our technology can streamline your operations and drive growth.
        </p>
        <div className="cta-row">
          <a href="/solutions" target="_blank">
            Explore Our Solutions
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More About Uebax
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Accelerate Efficiency</h2>
          <p>
            Leverage automation to optimize your workflows and reduce manual tasks, allowing your team to focus on what matters most.
          </p>
        </article>
        <article>
          <h2>Unlock Insights</h2>
          <p>
            Utilize advanced data analytics to gain actionable insights that drive informed decision-making and enhance performance.
          </p>
        </article>
        <article>
          <h2>Embrace Innovation</h2>
          <p>
            Integrate AI solutions that adapt to your business needs, fostering innovation and keeping you ahead of the competition.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;